export default __webpack_public_path__ + "static/media/web_SoundFX_254286__jagadamba__mechanical-switch.eda0a0bb.mp3";